'use client';
import { YellowButton } from '@/components/button/button';
import { Box, Container, GlobalStyles, Grid, Link, Stack, styled, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { sectionSpacingCss } from '../section-spacing';

const HeaderBox = styled(Box)`
  ${sectionSpacingCss}
  height: auto;
  min-height: 10vh;
  margin: 0;
  position: relative;
  overflow: hidden;
  color: white;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Title = styled(Typography)`
  padding-top: 1vh;
  font-family: var(--font-cooper-light), sans-serif;
  margin-bottom: 32px;
  width: 100%;
  text-shadow:
    0 0 20px rgba(31, 21, 33),
    0 0 20px rgba(31, 21, 33),
    0 0 20px rgba(31, 21, 33);
  @media (max-width: 768px) {
    width: 100%;
  }
  font-size: 40px;
  line-height: 1.368;
  color: #ffffff;
  text-align: center;
  max-width: 700px;
`;

export const WhyCoaching: React.FC<{ data?: any }> = ({ data }) => {
  return (
    <HeaderBox justifyContent="center">
      {/* Left ellipse SVG behind content */}
      <Container
        maxWidth="lg"
        sx={{
          mx: 'auto',
          minHeight: '50px',
          position: 'relative',
          zIndex: 99,
        }}
      >
        <Stack spacing={2} alignItems="center" justifyContent="center">
          <Title>
            {data?.heading ||
              `Discover how Curiko coaching is different. Over the past 10 years, we've evolved our practices to suit each person's unique needs.`}
          </Title>
        </Stack>
      </Container>
    </HeaderBox>
  );
};
